// Hands a Blob to the browser as a file download (the anchor-click pattern
// used by the order template download). Kept as a tiny module so callers
// (repositories) can be unit-tested with the browser side mocked away.
export function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
}
